export default "__VITE_ASSET__D0um4_c3__"